import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import {
  TechnologicalTransfer,
  TechnologicalTransferReclaimSearch,
  TechnologicalTransferRequest,
  TechnologicalTransferSearchRequest,
} from './TechnologicalTransferTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<TechnologicalTransfer>>('/author/technological-transfers/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<TechnologicalTransfer>(`/author/technological-transfers/${id}`).then(getData);
}

export function edit(id: Id, request: TechnologicalTransferRequest) {
  return axios.put<TechnologicalTransfer>(`/author/technological-transfers/${id}`, request).then(getData);
}

export function create(request: TechnologicalTransferRequest) {
  return axios.post<TechnologicalTransfer>(`/author/technological-transfers`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/technological-transfers/${id}`).then(getData);
}

export function searchByIdentifiers(request: TechnologicalTransferSearchRequest) {
  return axios
    .get<TechnologicalTransferReclaimSearch>('/author/technological-transfers/search/by-id', {
      params: {
        ...request,
      },
    })
    .then(getData);
}

export function reclaimAuthorship(technologicalTransferId: number, authorId: number) {
  return axios
    .post<unknown>(`/author/technological-transfers/${technologicalTransferId}/reclaim-authorship/${authorId}`)
    .then(getData);
}
